export default function review({ store, next, to }) {
  store.commit('review/reset')
  store.commit('review/set', { reminderType: to.meta.reminderType})

  next()
}
